import { useContext, useEffect, useState } from "react";
import { deviceInfoContext } from "../../context";
import { Input, Button } from "../../components/ui";
import useLogin from "./useLogin";
import Illustration from "../../assets/images/Illustration.svg";
import login_bg from "../../assets/images/login_bg.png";
import mpower from "../../assets/images/mpower.svg";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
const Login = () => {
  const { width } = useContext(deviceInfoContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { onLogin } = useLogin();
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const handleEnter = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onLogin(username, password);
      }
    };
    window.addEventListener("keydown", handleEnter);
    return () => window.removeEventListener("keydown", handleEnter);
  }, [username, password]);

  return (
    <>
      <div className="flex h-full" style={{ height: "100vh" }}>
        <div className="w-50 relative overflow-hidden">
          <img
            src={login_bg}
            alt=""
            aria-hidden="true"
            fetchPriority="high"
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div
            className="color_white absolute"
            style={{
              left: "40%",
              bottom: "25%",
              transform: "translate(-40%, -25%)",
            }}
          >
            <p className=" text-3xl font-bold">Admin Portal</p>
            <p className=" text-base">
              The Control Center for mOS{" "}
            </p>
          </div>
        </div>
        <div className="w-50 relative flex justify-center items-center screen_bg">
          <div className="px-3 flex justify-center items-center">
            <div className="border br-10 bg-white ">
              <div className="w-full py-6 px-[60px] border-b">
                {" "}
                <img
                  src={mpower}
                  alt="mPower"
                  decoding="async"
                  fetchPriority="high"
                  className="block h-auto max-w-full"
                />
              </div>
              <div className="py-8 px-[60px]">
                <p className="text-base font-bold mb-6">Account Login</p>
                <div className="flex gap-5 flex-col">
                  <div className="grow-[2]">
                    <Input
                      label="Email ID *"
                      value={username}
                      onChange={(e) => {
                        setUsername(e.target.value);
                      }}
                    />
                  </div>

                  <div className="grow-[2] relative">
                    <Input
                      label="Password *"
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-3 top-10 color-sub-text"
                    >
                      {showPassword ? (
                        <FaEyeSlash size={18} />
                      ) : (
                        <FaEye size={18} />
                      )}
                    </button>
                  </div>
                </div>
                <Button
                  className="mt-8"
                  styles={{ width: "20rem" }}
                  onClick={() => {
                    onLogin(username, password);
                  }}
                >
                  Login
                </Button>
                <div>
                  <p className="text-center text-sm mt-2 font-medium">
                    An <span className="color-primary ">ONO</span> Product
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img
            src={Illustration}
            alt=""
            aria-hidden="true"
            loading="lazy"
            decoding="async"
            className="absolute bottom-0 left-0 w-full pointer-events-none object-cover"
            style={{ height: "13rem" }}
          />
        </div>
      </div>
    </>
  );
};
export default Login;
